import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useI18n } from "@/i18n";

export function ResourcesHeader() {
  const { lang, toggle } = useI18n();
  return (
    <header className="sticky top-0 z-50 bg-midnight/90 backdrop-blur-xl border-b border-white/10" data-testid="resources-header">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="resources-logo-link"><Logo /></Link>
        <div className="flex items-center gap-5">
          <button onClick={toggle} data-testid="resources-lang-toggle" className="text-xs tracking-[0.2em] font-medium text-cream/70 hover:text-cream transition-colors">
            {lang === "it" ? "IT / EN" : "EN / IT"}
          </button>
          <Link to="/" data-testid="resources-back-link" className="hidden sm:inline text-sm text-cream/70 hover:text-cream link-underline">
            {lang === "it" ? "Torna al sito" : "Back to site"}
          </Link>
          <Link to="/#book" data-testid="resources-contact-btn" className="inline-flex items-center rounded-full bg-gold px-5 py-2.5 text-xs font-semibold tracking-[0.14em] uppercase text-midnight hover:scale-[1.04] transition-transform duration-300">
            {lang === "it" ? "Contattaci" : "Contact"}
          </Link>
        </div>
      </div>
    </header>
  );
}
